import React from 'react';
import PropTypes from 'prop-types';
import {useLocation, useHistory} from 'react-router-dom';
import {parse} from 'query-string';
import {captureError} from '../../utils/log';
import InvalidOrganisationDocumentsView from './InvalidOrganisationDocumentsView';

const pageSize = 10;

function InvalidOrganisationDocumentsContainer(props) {
  const history = useHistory();
  const location = useLocation();
  const [organisations, setOrganisations] = React.useState([]);
  const [page, setPage] = React.useState(typeof parse(location.search).page === 'undefined' ? 0 : Number(parse(location.search).page));
  const [totalCount, setTotalCount] = React.useState(0);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    setLoading(true);
    window.scrollTo(0, 0);
    props.onGetDocuments(page, pageSize)
      .then(response => {
        setOrganisations(response.organisations);
        setTotalCount(response.totalCount);
        setLoading(false);
      })
      .catch(error => captureError('Error while fetching invalid organisation documents', error));
  }, [page, props.country]);

  function handlePageChange(event, newPage = 0) {
    setPage(newPage);
    history.push(`${location.pathname}?page=${newPage}`);
  }

  return (
    <InvalidOrganisationDocumentsView
      loading={loading}
      organisations={organisations}
      totalCount={totalCount}
      pageSize={pageSize}
      pageNumber={page}
      onPageChange={handlePageChange}
      interventions={props.interventions}
      country={props.country}
      title={props.title}
    />
  );
}

InvalidOrganisationDocumentsContainer.propTypes = {
  country: PropTypes.string,
  userId: PropTypes.number,
  interventions: PropTypes.array,
  onGetDocuments: PropTypes.func.isRequired,
  title: PropTypes.element
};

export default InvalidOrganisationDocumentsContainer;
